module.exports = __webpack_public_path__ + "img/trans_key.c44d7bce.png";